module.exports = __webpack_public_path__ + "img/ico_fulizhongxin.4225db99.png";